module.exports = __webpack_public_path__ + "packs/media/images/bg-to-remove-4e1566a8f8774daae5f59acd5c27fa30.jpg";